import React, { useState, useEffect, useRef  } from 'react';
import { Typography, Button, Pagination } from 'antd';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import HomeBanner from './components/HomeBanner/HomeBanner';
import { getProductList } from '@/api/products';
import ProductList from './components/ProductList/ProductList';
import WebinarModal from './components/WebinarModal/WebinarModal';

const { Title } = Typography;
// 文件最上方（组件外）
let hasShownWebinarModal = false;
const Home: React.FC = () => {
  //国际化
  const { t, i18n } = useTranslation();

  const dispatch = useAppDispatch();

  //获取商品分类进行查询
  const getType = (type: number) => {
    console.log('home组件type', type);
  }

  const [params, setParams] = useState<any>({
    product_category_id: '',
    page_num: 1,
    page_size: 10,
    product_cateogry_brand_id: '',
    total: 0,
    totalPages: 0,
    product_title:''
  });

  // 是否加载中（用于防止重复触发）
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  // 使用 useRef 防止 StrictMode 重复执行
  const hasInitialized = useRef(false);

  //商品列表
  const [goodsList, setGoodsList] = useState<any[]>([]);

  // 弹框状态
  const [isModalOpen, setIsModalOpen] = useState<boolean>(() => !hasShownWebinarModal);

  useEffect(() => {
    if (!hasShownWebinarModal) {
      hasShownWebinarModal = true; // 首次加载后标记已展示
    }
  }, []);
  
  //获取商品列表方法
  const getProductListFn = (params: any) => {
    //console.log('home组件getProductListFn', params);
    setIsLoading(true);
    getProductList(params)
      .then((res) => {
        if (res.code == 200) {
          setGoodsList((prev) => [...prev, ...res.data]);

          // 这里为了处理调10次分页
          const nextParams = { 
            ...params, 
            page_num: params.page_num + 1 ,
            total: res.total || 0,
            totalPages: res.totalPages || 1,
          };
          setParams(nextParams);

          if(nextParams.page_num <= 10){
            getProductListFn(nextParams);
          }
        }
      })
      .finally(() => setIsLoading(false));
  }

  //mounted 和unmounted
  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      getProductListFn(params);
    }
  }, []);

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={styles['home-container']}>
      <HomeBanner />
      <ProductList getType={getType} goodsList={goodsList} />
      
      {/* <WebinarModal 
        open={isModalOpen}
        onClose={handleModalClose}
      /> */}
    </div>
  );
};

export default Home;